export enum MENU_KEY {
  AiModel = 'ai-model',
  Marketplace = 'marketplace',
  Campaign = 'campaign',
  Feed = 'feed',
  Farming = 'farming',
  Leaderboard = 'leaderboard',
  Pricing = 'pricing',
  Attendance = 'attendance',
  NftAuthen = 'nft-authentication',
}

export const MENU_LINK = {
  aiModel: '/ai-model',
  marketplace: '/marketplace',
  campaign: '/campaign',
  feed: '/feed',
  farming: '/farming',
  leaderboard: '/leaderboard',
  pricing: '/pricing',
  attendance: '/attendance',
  nftAuthen: 'https://nft-authenticity.airight.io/',
  botTele: 'https://t.me/aiRightAI_prod_bot',
};

export const MENU = [
  {
    key: MENU_KEY.AiModel,
    link: MENU_LINK.aiModel,
    text: 'Models',
  },
  {
    key: MENU_KEY.Farming,
    link: MENU_LINK.farming,
    text: 'Farming',
  },
  {
    key: MENU_KEY.Pricing,
    link: MENU_LINK.pricing,
    text: 'Pricing',
  },
  {
    key: MENU_KEY.Leaderboard,
    link: MENU_LINK.leaderboard,
    text: 'Leaderboard',
  },
  {
    key: MENU_KEY.Attendance,
    link: MENU_LINK.attendance,
    text: 'Daily Earn',
  },
];
